import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').CampaignDataEntity,
 *   ui: import('./ui').FollowUpUIReducer,
 * }} FollowUpReducer
 */

export default combineReducers({
  data,
  ui,
});
